import React from 'react';

import { sortBy } from 'lodash';
import SessionGraphs, {
  GraphBlueprint,
  GraphOptions,
  GraphSeries,
  GraphPoint,
  GraphInstanceProps
} from '../index';
import { FormatDate } from '../../../../libs/time';
import { IEpxBreastFeed } from '../../../../libs/apps/epxbreastfeed';

const EpxBreastFeedGraphs: React.FC<GraphInstanceProps> = (
  props
): JSX.Element => {
  const graph: GraphBlueprint<IEpxBreastFeed> = {
    name: 'BreastFeeding',
    config: {
      chart: {
        type: 'line'
      },
      title: {
        text: 'Breast Feeding'
      },
      xAxis: {
        type: 'category',
        tickmarkPlacement: 'on',
        title: {
          text: null
        }
      },
      yAxis: {
        title: {
          text: null
        },
        max: 1,
        min: -1,
        tickInterval: 1,
        labels: {
          formatter: function (this) {
            switch (this.value) {
              case -1:
                return 'Not B.f.';
              case 0:
                return 'Some B.f';
              case 1:
                return 'Exclusively B.f';
            }
          }
        }
      },
      responsive: {}
    },
    draw: (sessions) => {
      const options: GraphOptions = {
        series: []
      };
      const series: GraphSeries = {
        type: 'line',
        name: 'Breast Feeding Rate',
        tooltip: {
          pointFormatter: function (this) {
            let point = `<span style=\"color:${this.color};\">\u25CF</span><b>`;
            if (this.y === -1) {
              point += 'Not B.f.';
            } else if (this.y === 0) {
              point += 'Some B.f.';
            } else if (this.y === 1) {
              point += 'Exclusively B.f';
            }
            point += '</b></span><br />';
            return point;
          }
        }
      };
      const data: GraphPoint[] = [];
      sessions = sortBy(sessions, (session) => session.time);
      for (const [i, session] of sessions.entries()) {
        let bfeed = null;
        if (session.breastfeeding === 'N') {
          bfeed = -1;
        } else if (session.breastfeeding === 'S') {
          bfeed = 0;
        } else if (session.breastfeeding === 'A') {
          bfeed = 1;
        }
        data.push({
          id: String(session.id),
          name: FormatDate(session.time, 'MM/DD'),
          y: bfeed,
          x: i
        });
      }
      series.data = data;
      options.series = [series];
      return options;
    }
  };
  return (
    <SessionGraphs<IEpxBreastFeed>
      url="/data/data_by_range/"
      graphs={[graph]}
      {...props}
    />
  );
};

export default EpxBreastFeedGraphs;
